import { RpcService } from 'rpc';

export interface ISearchSvc extends RpcService {
	related_topics(params: { topicid: string; version: string; language: string }): Promise<string[]>;
}

export const svc: ISearchSvc = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/@@learningpath.rpc`,

	services: {
		related_topics: {
			parameters: [
				{
					name: 'topicid',
					type: 'string',
					optional: false
				},
				{
					name: 'version',
					type: 'string',
					optional: false
				},
				{
					name: 'language',
					type: 'string',
					optional: false
				}
			]
		}
	}
}) as ISearchSvc;

export default svc;
